import React, { useEffect, useState } from "react";
import { Box, Button, Grid, Paper } from "@material-ui/core";
import { useStyles } from "../../../shared/styles/useStyles";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import BackupIcon from "@material-ui/icons/Backup";
import {
  getAll,
  getResponseTimesParams,
} from "../../../services/backups/service.firebase";
import {
  generateExcelFile,
  generateExcelFileName,
} from "../../../helpers/downloadExcel";
import { mapCorrespondenceToExcel } from "../../../helpers/excelMappers";
import { MyTextField } from "../../../components/custom/MyTextField";
import { Form, Formik, FormikHelpers } from "formik";
import clsx from "clsx";

/**
 * This is Component for generate backups full-data
 * @returns
 */
export const BackupComponent = (props) => {
  /**
   * States here
   */
  const classes = useStyles();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const [values, setValues] = useState({ range: 0 });
  const [rangeDate, setRangeDate] = useState(null);

  const initialValues = {
    startDate: new Date().toLocaleDateString("en-CA"),
    endDate: new Date().toLocaleDateString("en-CA"),
  };

  const handleDownload = async (response: any) => {
    try {
      const data = response.data;
      const paramResponseTime = await getResponseTimesParams(user.idEntity);

      const transformedData = await mapCorrespondenceToExcel(
        data,
        paramResponseTime,
        {},
        []
      );

      const fileName = generateExcelFileName("Backup");

      generateExcelFile("Sheet", transformedData, () => fileName);
    } catch (error) {
      console.error(
        "Ocurrió un error al intentar descargar el respaldo:",
        error
      );
    }
  };

  const handleSubmit = async (
    values: any,
    { setSubmitting }: FormikHelpers<any>
  ) => {
    const { startDate, endDate } = values;
    if (new Date(startDate) > new Date(endDate)) {
      console.warn("Ingrese un rango válido!");
      setSubmitting(false);
      return;
    }

    const response = await getAll(
      user.idEntity,
      startDate,
      endDate
    );

    handleDownload(response);
    setSubmitting(true);

    setSubmitting(false);
  };

  /**
   * Effects here
   */
  useEffect(() => {
    if (!user) return;
  }, []);

  return (
    <Box mt={1} mb={3}>
      <Formik
        validateOnChange={true}
        initialValues={initialValues}
        onSubmit={handleSubmit}
      >
        {({ handleChange, setFieldValue }) => (
          <Form className={classes.input}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <FormattedMessage id="From" />
                <MyTextField
                  name="startDate"
                  variant="outlined"
                  type="date"
                  onChange={handleChange}
                  className={classes.myTextDate}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <FormattedMessage id="To" />
                <MyTextField
                  name="endDate"
                  variant="outlined"
                  type="date"
                  onChange={handleChange}
                  className={classes.myTextDate}
                />
              </Grid>

              <Grid
                item
                xs={12}
                sm={4}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Button
                  className={clsx(classes.btnAction, classes.save)}
                  autoFocus
                  type="submit"
                  style={{ marginTop: "20px", height: "39px" }}
                >
                  <BackupIcon style={{ marginRight: 5 }} />
                  <FormattedMessage id="DownloadBackup" />{" "}
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );

  // return (
  //   <AppAnimate animation={"transition.slideUpIn"} delay={200}>
  //     <Paper square className={classes.paper}>
  //       <Box mb={3} p={3} fontSize={20}>
  //         <Grid container>
  //           <Grid item xs={6}>
  //             <Box>
  //               <label className={classes.typography}>
  //                 <FormattedMessage id="SelectDateRange" />
  //               </label>
  //               <DatePickerRange
  //                 range={rangeDate}
  //                 handleDateRange={handleDateRange}
  //               />
  //             </Box>
  //           </Grid>
  //           <Grid item xs={6}>
  //             <Box mt={4} marginLeft={5}>
  //               <Button
  //                 size="large"
  //                 variant="contained"
  //                 color="secondary"
  //                 className={classes.btnAdd}
  //                 type="button"
  //                 onClick={handleDownload}
  //               >
  //                 <BackupIcon style={{ marginRight: 5 }} />
  //                 <FormattedMessage id="DownloadBackup" />
  //               </Button>
  //             </Box>
  //           </Grid>
  //         </Grid>
  //       </Box>
  //     </Paper>
  //   </AppAnimate>
  // );
};
